module.exports = __webpack_public_path__ + "img/744.ee63bc08.jpg";